const numberPath = '/v1/number-frame.html';
const cvvPath = '/v1/cvv-frame.html';

export {
  numberPath,
  cvvPath,
};
